module.exports = __webpack_public_path__ + "assets/img/home.c976802b.svg";